<template>
    <div class="pt-8">
        <div class="border border-gray-400 px-3 sm:px-6 pb-8 mb-8">
            <zoning-change-required
                v-model="zoning_change_is_required"
                :commercial="commercial"
                :read_only="read_only"
            />

            <div v-if="zoning_change_is_required">
                <zoning-change-items
                    :commercial="commercial"
                    :read_only="read_only"
                />

                <zoning-change-who-pays
                    :commercial="commercial"
                    :read_only="read_only"
                />

                <zoning-change-applied-for
                    :commercial="commercial"
                    :read_only="read_only"
                />

                <zoning-change-review-dates
                    :commercial="commercial"
                    :read_only="read_only"
                />
            </div>
        </div>
    </div>
</template>

<script>
import ZoningChangeRequired from './zoning-change-required.vue';
import ZoningChangeItems from './zoning-change-items.vue';
import ZoningChangeWhoPays from './zoning-change-who-pays.vue';
import ZoningChangeAppliedFor from './zoning-change-applied-for.vue';
import ZoningChangeReviewDates from './zoning-change-review-dates.vue';

export default {
    components: {
        ZoningChangeRequired,
        ZoningChangeItems,
        ZoningChangeWhoPays,
        ZoningChangeAppliedFor,
        ZoningChangeReviewDates,
    },

    props: {
        commercial: { default: () => ({}) },
        read_only: { default: false },
    },

    computed: {
        zoning_change_is_required() {
            return store.state.zoning_change_is_required;
        },
    },
}
</script>
